/*
 * File: index.ts
 * File Created: 2024-02-02 07:43:38
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-12-23 08:17:17
 * Modified By: Val Liu
 * -----
 */

// import { ALLOW_GENERAL_MODIFY, ALLOW_GENERAL_READ } from "@/helpers/permission-helper";
import { PARAMS_INCLUDE, PARAMS_WHERE } from "@/views/core";
import { IPermissionCheck, ObjectHelper, Vue } from "@root/core";
import { IQuickUnit, UIQuick } from "@root/core/utilities/quick-helper";
// import { EWarrantRolePermission } from "shared-taiwan-bank-life-insurance";
const _ = UIQuick.getInstance;

// const rolePermission: EWarrantRolePermission = EWarrantRolePermission.系統維護管理作業;

@UIQuick.set()
export class Warrant extends IQuickUnit {
    title = "w_WarrantManagement";
    path = "/warrant";
    icon = "fa-solid fa-id-badge";

    value = [
        {
            warrantId: "MJIB01_A1141091B",
            executerId: "MJIB01",
            startRecordingAt: new Date(2024, 9, 18, 15, 0, 0),
            endRecordingAt: new Date(2024, 10, 18, 15, 0, 0),
            rawData: "工作中",
            targets: 1,
            startValidAt: "永久",
            endValidAt: "永久",
            createdAt: new Date(2024, 9, 18, 14, 41, 19),
            updatedAt: new Date(2024, 9, 20, 16, 12, 55),
        },
        {
            warrantId: "MJIB01_A1141091B",
            executerId: "MJIB01",
            startRecordingAt: new Date(2024, 9, 18, 15, 0, 0),
            endRecordingAt: new Date(2024, 10, 18, 15, 0, 0),
            rawData: "工作中",
            targets: 1,
            startValidAt: "永久",
            endValidAt: "永久",
            createdAt: new Date(2024, 9, 18, 14, 41, 19),
            updatedAt: new Date(2024, 9, 20, 16, 12, 55),
        },
        {
            warrantId: "MJIB01_A1141091B",
            executerId: "MJIB01",
            startRecordingAt: new Date(2024, 9, 18, 15, 0, 0),
            endRecordingAt: new Date(2024, 10, 18, 15, 0, 0),
            rawData: "工作中",
            targets: 1,
            startValidAt: "永久",
            endValidAt: "永久",
            createdAt: new Date(2024, 9, 18, 14, 41, 19),
            updatedAt: new Date(2024, 9, 20, 16, 12, 55),
        },
        {
            warrantId: "MJIB01_A1141091B",
            executerId: "MJIB01",
            startRecordingAt: new Date(2024, 9, 18, 15, 0, 0),
            endRecordingAt: new Date(2024, 10, 18, 15, 0, 0),
            rawData: "工作中",
            targets: 1,
            startValidAt: "永久",
            endValidAt: "永久",
            createdAt: new Date(2024, 9, 18, 14, 41, 19),
            updatedAt: new Date(2024, 9, 20, 16, 12, 55),
        },
        {
            warrantId: "MJIB01_A1141091B",
            executerId: "MJIB01",
            startRecordingAt: new Date(2024, 9, 18, 15, 0, 0),
            endRecordingAt: new Date(2024, 10, 18, 15, 0, 0),
            rawData: "工作中",
            targets: 1,
            startValidAt: "永久",
            endValidAt: "永久",
            createdAt: new Date(2024, 9, 18, 14, 41, 19),
            updatedAt: new Date(2024, 9, 20, 16, 12, 55),
        },
    ];

    /// hireachy
    parents = null;
    children = () => [_`MonitoringTarget`];

    /// file
    file = ["files", "monitoringTargets"];

    /// toolbox
    toolboxRead = `<ivc-warrant-toolbox v-bind="$attrs" />`;

    /// params
    paramsWhere = PARAMS_INCLUDE;
    paramsRead = PARAMS_INCLUDE;
    paramsUpdate = PARAMS_INCLUDE;

    /// props
    propsRead = function (this: IQuickUnit): any {
        return {
            interval: 1000,
        };
    };

    /// interfaces
    infDetail = require("raw-loader!./interfaces/warrant.create.interface").default;
    infRead = require("raw-loader!./interfaces/warrant.read.interface").default;
    infCreate = require("raw-loader!./interfaces/warrant.create.interface").default;
    infUpdate = require("raw-loader!./interfaces/warrant.create.interface").default;
    infDelete = require("raw-loader!./interfaces/warrant.delete.interface").default;

    /// auth
    // allowRead = ALLOW_GENERAL_READ(rolePermission);
    // allowCreate = ALLOW_GENERAL_MODIFY(rolePermission);
    // allowUpdate = ALLOW_GENERAL_MODIFY(rolePermission);
    //allowDelete = ALLOW_GENERAL_MODIFY(rolePermission);
}
